import React from 'react'

import FilterPopover, {
  FilterPopoverProps
} from 'components_new/molecules/FilterPopover'
import SearchAndSelect from 'components_new/molecules/SearchAndSelect'
import { Option } from 'components_new/molecules/SelectSearch'

import { useTranslation } from 'language/translator'
import { SxProps } from '@mui/material'

interface StandardFilterProps {
  disabled?: boolean
  fullWidth?: boolean
  loading?: boolean
  onChange: (value: string[]) => void
  options: Option[]
  selected: string[]
  size?: FilterPopoverProps['size']
  sx?: SxProps
  title?: string
}

const StandardFilter = React.forwardRef(
  (props: StandardFilterProps, ref: React.Ref<HTMLDivElement>) => {
    const {
      disabled,
      fullWidth,
      loading,
      onChange,
      options,
      selected,
      size,
      sx,
      title
    } = props

    const { t } = useTranslation()

    const valueLabel =
      selected.length > 0
        ? selected
          .map((so) => {
            return options.find((o) => o.id === so)?.title
          })
          .join(', ')
        : t('global', 'all')

    return (
      <FilterPopover
        active={selected.length > 0}
        disabled={disabled}
        loading={loading}
        popoverWidth={300}
        primary={title}
        ref={ref}
        secondary={valueLabel}
        size={size}
        sx={{
          ...(fullWidth ? null : { maxWidth: 172, minWidth: 128 }),
          ...sx
        }}
        tooltipTitle={title}
        tooltipValue={valueLabel}
      >
        <SearchAndSelect
          autoFocus={true}
          multiple={true}
          onChange={onChange}
          options={options}
          size="small"
          sx={{ p: 2 }}
          value={selected}
        />
      </FilterPopover>
    )
  }
)

StandardFilter.displayName = 'StandardFilter'

export default StandardFilter
